import { useCallback, useState } from 'react';
import type { Dayjs } from 'dayjs';
import {
  readStoredKanbanSort,
  writeStoredKanbanSort,
  type KanbanSortOption,
} from '@evimo/components/maintenance/work-orders/WorkOrderKanbanPageContainer/utils';

/**
 * Local filter / sort state for the Kanban board (site, tech, plan, due range,
 * follow-up-only, persisted sort preference).
 */
export function useWorkOrderKanbanFilters() {
  const [siteFilter, setSiteFilter] = useState('');
  const [technicianFilter, setTechnicianFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');
  const [kanbanSort, setKanbanSortState] = useState<KanbanSortOption>(() =>
    readStoredKanbanSort(),
  );
  const [dueRange, setDueRange] = useState<[Dayjs | null, Dayjs | null] | null>(
    null,
  );
  const [followUpOnly, setFollowUpOnly] = useState(false);

  const setKanbanSort = useCallback((value: KanbanSortOption) => {
    setKanbanSortState(value);
    writeStoredKanbanSort(value);
  }, []);

  return {
    siteFilter,
    setSiteFilter,
    technicianFilter,
    setTechnicianFilter,
    planFilter,
    setPlanFilter,
    kanbanSort,
    setKanbanSort,
    dueRange,
    setDueRange,
    followUpOnly,
    setFollowUpOnly,
  };
}
